// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Education(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Education" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M5.63636 13.0489V16.6044L12 20L18.3636 16.6044V13.0489L12 16.4444L5.63636 13.0489ZM12 4L2 9.33333L12 14.6667L20.1818 10.3022V16.4444H22V9.33333L12 4Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Education.js.map